import useId from '../utils/useId';
import * as React from 'react';
export const hipaySvg = React.forwardRef(function hipaySvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FF3B63',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_hipay__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3.012 20.229c-.099.56.427.95.885.686l1.554-.898a3.465 3.465 0 0 1 1.809-.484h2.947c.886 0 1.63-.623 1.783-1.496l.99-5.621a1.203 1.203 0 0 0-1.187-1.417c-1.879 0-3.758.002-5.636.003a1.8 1.8 0 0 0-1.782 1.495c-.456 2.585-.903 5.128-1.363 7.731Zm7.413-6.98.095-.54a.6.6 0 0 1 .595-.5h.699l-.095.54a.6.6 0 0 1-.595.5h-.699Zm-2.475.271c1.154 0 1.68.853 1.487 1.936l-.422 2.371a.6.6 0 0 1-.595.5h-.7l.475-2.723c.101-.58-.141-.961-.754-.961-.644 0-1.093.398-1.202 1.01l-.447 2.53a.587.587 0 0 1-.293.418l-1.1.635 1.152-6.526a.6.6 0 0 1 .595-.5h.699l-.343 1.95c.362-.425.843-.639 1.447-.639h.001Zm1.58 4.806.738-4.175a.6.6 0 0 1 .595-.5h.7l-.739 4.176a.6.6 0 0 1-.595.5h-.7Zm19.066-4.675h1.098l-2.49 4.675c-.378.712-.796 1.208-1.249 1.492-.452.283-.97.41-1.557.378l.14-.806a.397.397 0 0 1 .347-.33c.197-.024.362-.081.494-.168.194-.128.365-.362.543-.688l.027-.051-1.118-4.503h.917a.41.41 0 0 1 .392.316l.757 2.688 1.344-2.793a.38.38 0 0 1 .354-.21Zm-7.276 3.657c.361 0 .683-.114.963-.34.28-.227.474-.524.542-.901l.028-.156c.068-.378-.031-.682-.243-.906-.211-.223-.496-.335-.851-.335-.368 0-.692.117-.972.35-.281.234-.454.554-.524.96-.068.392-.003.711.196.958.2.246.486.37.86.37Zm2.267-3.657h.87l-.765 4.343a.4.4 0 0 1-.396.332h-.869l.075-.424c-.405.37-.922.555-1.552.555-.704 0-1.228-.259-1.57-.776-.343-.517-.445-1.118-.318-1.805a2.964 2.964 0 0 1 .902-1.678 2.45 2.45 0 0 1 1.735-.678c.66 0 1.142.253 1.441.758l.052-.295a.4.4 0 0 1 .396-.332Zm-6.245 2.347c.069-.393.005-.712-.191-.958-.197-.247-.482-.37-.856-.37-.356 0-.672.109-.95.325a1.566 1.566 0 0 0-.556.86l-.043.238c-.043.374.042.67.255.887.214.218.499.327.854.327.362 0 .683-.117.964-.35.28-.235.455-.554.523-.96v.001Zm-.698-2.478c.66 0 1.17.258 1.529.772.358.515.481 1.111.37 1.79a2.888 2.888 0 0 1-.861 1.684 2.377 2.377 0 0 1-1.72.692c-.686 0-1.183-.262-1.492-.787l-.401 2.262a.4.4 0 0 1-.396.332h-.87l1.108-6.28a.4.4 0 0 1 .396-.333h.869l-.084.48c.411-.407.929-.611 1.552-.611Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_hipay__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(3 11)',
          d: 'M0 0h26.693v10H0z',
        }),
      ),
    ),
  );
});
hipaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hipay = {
  category: 'brand',
  colorable: false,
  name: 'hipay',
  svg: hipaySvg,
};
